<template>
  <div class="infoHome" id="informacoes-gerais">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <TitleSection>Informações Gerais</TitleSection>
        </div>
        <div class="col-12 col-lg-5">
          <img class="img-fluid" :src="HomeInfoParte1">
        </div>
        <div class="col-12 col-lg-5 colum2">
          <img class="img-fluid" :src="HomeInfoParte2">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleSection from '@/components/TitleSection'
import HomeInfoParte1 from '@/images/homeInfoParte1.svg'
import HomeInfoParte2 from '@/images/homeInfoParte2.svg'

export default {
  name: 'infoHome',
  components: {
    TitleSection
  },
  data: () => ({
    HomeInfoParte1,
    HomeInfoParte2,
  })
}
</script>

<style lang="scss" scoped>
.infoHome {
  padding-bottom: 100px
}
.colum2 {
  @media (max-width: 992px) {
    margin-top: 30px;
  }
}
</style>
